import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Form, FormFeedback, Input, Label, Row, Spinner } from 'reactstrap';
import * as Yup from 'yup';

//import images
import AuthSlider from '../authCarousel';
import { useFormik } from 'formik';
import { getSignupDTO, sendFirebaseOTP, signUp } from 'slices/auth/register/thunk';
import { useDispatch } from 'react-redux';
import withRouter from 'Components/Common/withRouter';
import CheckVerify from "../../../assets/images/checkverify.png"
import SimpleBar from 'simplebar-react';
import { ToastContainer } from 'react-toastify';
import { resendOtpCode, sendOtpCode, verifyOtpCode } from 'live-slices/auth/register/thunk';
import TermsPrivacyPopup from 'Components/Common/termAndConditions';

let timeout: any;

const CoverTwosVerify = (props: any) => {
    const dispatch: any = useDispatch();
    const [otpError, setOtpError] = useState<string>("");
    const [otpValues, setOtpValues] = useState(Array(6).fill(""));
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    document.title = "OTP Verification";
    const navigate = useNavigate();
    const [resendTimer, setResendTimer] = useState(-1);
    const [resendTimerByresend, setResendTimerByresend] = useState(60);
    const [loader, setLoader] = useState<boolean>(false);

    const firstInputRef = useRef<HTMLInputElement>(null);
    const [otpStatus, setOtpStatus] = useState(Array(6).fill("")); // Track field status
    const location = useLocation();
    const { numberId, phoneNumber, isVOTP } = location.state || {};
    const [verificationId, setVerificationId] = useState<string | null>(null);
    const [storedId, setStoredId] = useState<string | null>(null)
    const [termAndConditonModal, setTermAndConditonModal] = useState(false);
    const [type, setType] = useState<'terms' | 'privacy'>("terms");
    // const [isVOTP, setIsVOTP] = useState(false);


    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        // sentInitialCode();
    }, [])

    const sentInitialCode = (isResend: boolean = false) => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
            const res = await dispatch(
                resendOtpCode({ id: numberId, isVOTP: isVOTP })
            ).unwrap();

            if (res) {
                const { _id } = res;
                setStoredId(_id);
                setResendTimerByresend(60);
            } else {
                handleBack();
            }
        }, 1000);
    };

      const handleShowPopup = (type : any) => {
    setType(type);
    setTermAndConditonModal(true);
  };

    useEffect(() => {
        let timerInterval: any;

        if (resendTimerByresend > 0) {
            timerInterval = setInterval(() => {
                setResendTimerByresend((prev) => prev - 1);
            }, 1000);
        } else {
            clearInterval(timerInterval);
        }

        return () => clearInterval(timerInterval);
    }, [resendTimerByresend]);

    const getInputElement = (index: any): HTMLInputElement => {
        return document.getElementById('digit' + index + '-input') as HTMLInputElement;
    }

    // const verifyOtp = (otpCode: string) => {
    //     if (/^\d{6}$/.test(otpCode)) {
    //         setIsOtpVerified(true);
    //     } else {
    //         setIsOtpVerified(false);
    //     }
    // };

    useEffect(() => {
        if (otpValues.every((val) => val !== "")) {
            const otpCode = otpValues.join("");
            // verifyOtp(otpCode);
        }
    }, [otpValues]);




    const handleBack = () => {
        navigate(-1);
    };

    const handleKeyPress = async (e: any, index: any) => {
        try {
            if (otpError) setOtpError("");
            const input = getInputElement(index);
            const value = input.value;
            if (value.length === 1 && index < 6 && e.key !== "Backspace") {
                getInputElement(index + 1)?.focus();
            }
            if (e.key === "Backspace" && index > 1 && value.length === 0) {
                validateField(index, value); // Validate the field on input
                getInputElement(index - 1)?.focus(); // Focus the previous input
            }

            if (value.length === 1 && index === 6) {
                validateField(index, value); // Validate the last field
                input.blur(); // Remove focus from the last field
                const otpCode = Array.from({ length: 6 })
                    .map((_, idx) => getInputElement(idx + 1).value)
                    .join("");
                const idToVerify = storedId || numberId;

                const response = await dispatch(
                    verifyOtpCode({ code: otpCode, id: idToVerify, })
                ).unwrap();
                setVerificationId(response.verificationId);
                console.log(response.verificationId)
                if (response._id) {
                    setIsOtpVerified(true);
                }
                else {
                    setIsOtpVerified(false);
                    setOtpError("Invalid Code")
                }
            }
        } catch (error) {
            console.error("OTP Verification Error: ", error);
            setOtpError("An error occurred during OTP verification. Please try again.");
            setIsOtpVerified(false);
            // const global = window as any;
            // const confirmationResult = global.confirmationResult;

            // Attempt OTP verification
            // const result = await confirmationResult.confirm(otpCode);

            // Check verification result
            // if (result && result.user) {
            //     setIsOtpVerified(true);
            // } else {
            //     setIsOtpVerified(false);
            // }
        }
    };



    const validateField = (index: number, value: string) => {
        const isValid = value === "1"; // Example validation: "1" is correct
        const updatedStatus = [...otpStatus];
        updatedStatus[index - 1] = isValid ? "Verified" : "Not Verified";
        setOtpStatus(updatedStatus);
    };

      const [isChecked, setIsChecked] = useState(false);
      const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
      };

    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [confrimPasswordShow, setConfrimPasswordShow] = useState<boolean>(false);

    const [charLimitError, setCharLimitError] = useState(false);
    const [changePasscharLimitError, setChangePassCharLimitError] = useState(false);

      const handlePasswordChange = (e:any) => {
    const value = e.target.value;

    // Check character limit
    if (value.length > 20) {
      setCharLimitError(true);
    } else {
      setCharLimitError(false);
      validation.setFieldValue("password", value);
    }
  };

    const handleConfirmPasswordChange = (e:any) => {
    const value = e.target.value;

    if (value.length > 20) {
      setChangePassCharLimitError(true);
    } else {
      setChangePassCharLimitError(false);
      validation.setFieldValue("confirm_password", value);
    }
  };

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            password: "",
            confirm_password: "",
            email: "",
            fullName: "",
            // acceptedTerms : false,
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, 'Password must be at least 8 characters. At least one lowercase letter, one uppercase letter, and one number')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/,
                    'Password must include at least one lowercase letter, one uppercase letter, one number, and one special character'
                )
                .required('This field is required'),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password'), ''], 'Password does not match')
                .required('Confirm Password is required'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            fullName: Yup.string()
                .required('Full Name is required'),
    //         acceptedTerms: Yup.boolean()
    //   .oneOf([true], 'This field is required')
    //   .required('This field is required'),
        }),

        onSubmit: async (values) => {
            const otpCode = Array.from({ length: 6 })
                .map((_, idx) => getInputElement(idx + 1).value)
                .join("");
            try {
                setLoader(true);
                await new Promise((resolve) => setTimeout(resolve, 0)); // Ensure loader shows
                // const phoneNumber = getSignupDTO()?.phoneNumber || "";
                const signupData = {
                    ...values,
                    phoneNumber: getSignupDTO()?.phoneNumber,
                    verificationId,
                };
                await dispatch(signUp(signupData, props.router.navigate));
                setLoader(false);
            } catch (error: any) {
                setLoader(false);
                setOtpError("Invalid OTP code. Please try again.");
                console.error("OTP Verification Error:", error);
            }

        }
        // dispatch(signUp({ ...values, phoneNumber: getSignupDTO().phoneNumber }, props.router.navigate));

    });

    return (
        <React.Fragment>
            <ToastContainer />
            <div id="bp-fb-ver" ></div>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100 mobileScrolHight auth-form">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden ">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="Specific-Class-for-border cardHightDv overflow-hidden">
                                    <Row className="justify-content-center g-0 h-100">
                                        <AuthSlider />
                                        <Col lg={6} >
                                            <div className='d-flex justify-content-center align-items-center '>
                                                <div className="height-of-login p-lg-5 p-4">

                                                    <div className="text-muted text-center mx-lg-3">
                                                        <h4 className="">Enter the Code</h4>
                                                        <p>
                                                            Enter the 6 digit code sent to
                                                            <span className="fw-semibold"> {getSignupDTO()?.phoneNumber} </span>
                                                            {isVOTP ? "via call" : "in SMS"} <br />
                                                            <Link to="/register" className="fw-semibold text-secondary" style={{ textDecoration: 'underline', }} data-testing-id="changeNumberLink_OtpVerification">
                                                                Change Number
                                                            </Link>
                                                        </p></div>
                                                    <Form onSubmit={validation.handleSubmit} action="/auth-signin-basic">
                                                        <div className="mt-4">
                                                            <Row>
                                                                {Array.from({ length: 6 }).map((_, index) => (
                                                                    <Col className="col-2" key={index}>
                                                                        <div className="mb-3">
                                                                            <label
                                                                                htmlFor={`digit${index + 1}-input`}
                                                                                className="visually-hidden"
                                                                            >
                                                                                Digit {index + 1}
                                                                            </label>
<input
    ref={index === 0 ? firstInputRef : null}
    type="number"
    style={{ border: "2px solid #E2E7EA" }}
    className="form-control form-control-lg bg-light text-center otpInput"
    maxLength={1}
    data-testing-id={`otpCodeInput_otpVerification${index}`}
    id={`digit${index + 1}-input`}
    value={otpValues[index]}
    onKeyUp={(e) => handleKeyPress(e, index + 1)}
    onChange={(e) => {
        const newOtpValues = [...otpValues];
        newOtpValues[index] = e.target.value;
        setOtpValues(newOtpValues);
    }}
    onPaste={(e) => {
        const paste = e.clipboardData.getData('text');
        if (/^\d{6}$/.test(paste)) {
            e.preventDefault();
            setOtpValues(paste.split(''));
            // Optionally, move focus to last input
            setTimeout(() => {
                const lastInput = document.getElementById('digit6-input');
                lastInput?.focus();
            }, 0);
        }
    }}
/>
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                                {otpError && <div className="text-danger text-center">{otpError}</div>}
                                                            </Row>

                                                            <div>
                                                                <div className="d-flex justify-content-between align-items-center mt-0 mb-3">
                                                                    <div></div>
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        {otpValues.every((val) => val !== "") && isOtpVerified ? null : (
                                                                            <>
                                                                                {resendTimerByresend > 0 ? (
                                                                                    <p className="text-muted">
                                                                                        Resend code in{" "}
                                                                                        <span className="fw-semibold">{resendTimerByresend}s</span>
                                                                                    </p>
                                                                                ) : (
                                                                                    <div
                                                                                        onClick={() => sentInitialCode(true)}
                                                                                        className="fw-semibold text-secondary"
                                                                                        style={{ textDecoration: "underline", cursor: "pointer" }}
                                                                                    >
                                                                                        Didn't receive a code? Resend Code
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div>
                                                                        {otpValues.every((val) => val !== "") && isOtpVerified ? (
                                                                            <div className='d-flex'>
                                                                                <img
                                                                                    src={CheckVerify}
                                                                                    alt="Verified"
                                                                                    className="me-1"
                                                                                    height={18}
                                                                                    width={18}
                                                                                />
                                                                                <p className="text-success fw-semibold mb-0 fs-12">Verified</p>
                                                                            </div>
                                                                        ) : (
                                                                            <></>
                                                                            // <p className="text-danger fw-semibold mb-0 fs-10">Not Verified</p>
                                                                        )}
                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className=" formContainer ">
                                                            <label className="form-label" htmlFor="email-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Full Name</label>
                                                            <Input
                                                                name="fullName"
                                                                className="form-control leftPad"
                                                                placeholder="Abdul Rehman"
                                                                data-testing-Id="fullNameInput_otpVerification"
                                                                type="text"
                                                                value={validation.values.fullName}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.fullName && validation.touched.fullName ? true : false}
                                                            />
                                                            {validation.errors.fullName && validation.touched.fullName ? (
                                                                <FormFeedback type="invalid">{validation.errors.fullName}</FormFeedback>
                                                            ) : null}
                                                            <i className="ri-user-line text-secondary lefticonInfoDv"></i>

                                                        </div>

                                                        <div className=" formContainer ">
                                                            <label className="form-label" htmlFor="email-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Email</label>
                                                            <Input
                                                                name="email"
                                                                className="form-control leftPad"
                                                                placeholder="abdul@xyz.com"
                                                                data-testing-Id="emailInput_otpVerification"
                                                                type="text"
                                                                value={validation.values.email}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.email && validation.touched.email ? true : false}
                                                            />
                                                            {validation.errors.email && validation.touched.email ? (
                                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                            ) : null}
                                                            <i className="ri-mail-line text-secondary lefticonInfoDv"></i>

                                                        </div>


                                                        <div className="formContainer">
      <label className="form-label" htmlFor="password-input">
        <span style={{ color: "red", display: "inline" }}>*</span> Password
      </label>
      <div className="position-relative auth-pass-inputgroup mb-3">
        <Input
          name="password"
          type={passwordShow ? "text" : "password"}
          className="form-control leftPad"
          placeholder="MyP@ssw0rd123"
          data-testing-Id="passwordInput_login"
          value={validation.values.password}
          onBlur={validation.handleBlur}
          onChange={handlePasswordChange}
          invalid={
            (validation.errors.password && validation.touched.password) || charLimitError
              ? true
              : false
          }
        />

        {(validation.errors.password && validation.touched.password) && (
          <FormFeedback type="invalid">
            {validation.errors.password}
          </FormFeedback>
        )}

        {charLimitError && (
          <FormFeedback type="invalid">
            Password cannot exceed 20 characters.
          </FormFeedback>
        )}

        <button
          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
          onClick={() => setPasswordShow(!passwordShow)}
          type="button"
          id="password-addon"
          data-testing-id="eyeIconpassword_otpVerification"
        >
          <i className="ri-eye-fill align-middle"></i>
        </button>
        <i className="bx bx-key text-secondary lefticonInfoDv"></i>
      </div>
    </div>


                                                        <div className="formContainer">
      <label className="form-label" htmlFor="password-input">
        <span style={{ color: "red", display: "inline" }}>*</span> Confirm Password
      </label>
      <div className="position-relative auth-pass-inputgroup mb-3">
        <Input
          name="confirm_password"
          type={confrimPasswordShow ? "text" : "password"}
          className="form-control leftPad"
          placeholder="MyP@ssw0rd123"
          value={validation.values.confirm_password}
          onBlur={validation.handleBlur}
          onChange={handleConfirmPasswordChange}
          invalid={
            (validation.errors.confirm_password && validation.touched.confirm_password) || changePasscharLimitError
          }
          data-testing-id="confirmPasswordInput_otpVerification"
        />
        {(validation.errors.confirm_password && validation.touched.confirm_password) && (
          <FormFeedback type="invalid">
            {validation.errors.confirm_password}
          </FormFeedback>
        )}
        {changePasscharLimitError && (
          <FormFeedback type="invalid">
            Confirm Password cannot exceed 20 characters.
          </FormFeedback>
        )}

        <button
          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
          onClick={() => setConfrimPasswordShow(!confrimPasswordShow)}
          type="button"
          id="password-addon"
          data-testing-id="eyeIconConpassword_otpVerification"
        >
          <i className="ri-eye-fill align-middle"></i>
        </button>
        <i className="bx bx-key text-secondary lefticonInfoDv"></i>
      </div>
    </div>

                                                        <div id="password-contain" className="p-3 bg-light mb-2 rounded">
                                                            <h5 className="fs-13">Password must contain:</h5>
                                                            <p id="pass-length" className="invalid fs-12 mb-2">Minimum <b>8 characters</b></p>
                                                            <p id="pass-lower" className="invalid fs-12 mb-2">At <b>lowercase</b> letter (a-z)</p>
                                                            <p id="pass-upper" className="invalid fs-12 mb-2">At least <b>uppercase</b> letter (A-Z)</p>
                                                            <p id="pass-number" className="invalid fs-12 mb-0">A least <b>number</b> (0-9)</p>
                                                        </div>

                                                        {/* <div className=" formContainer">
                                                            <label className="form-label" htmlFor="email-input">Referal Code</label>
                                                            <Input
                                                                name="referal"
                                                                className="form-control leftPad"
                                                                placeholder="BA4078"
                                                                lassName="form-control pe-5 password-input"
                                                                data-testing-Id="referalCodeInput_otpVerification"
                                                                id="referal-input"

                                                            />

                                                            <i className="ri-share-line text-secondary lefticonInfoDv"></i>

                                                        </div> */}


            {/* <div className="form-check mb-2">
  <input
    type="checkbox"
    id="acceptedTerms"
    name="acceptedTerms"
    className={`form-check-input ${
      validation.touched.acceptedTerms && validation.errors.acceptedTerms
        ? 'is-invalid'
        : ''
    }`}
    checked={validation.values.acceptedTerms}
    onChange={(e) =>
      validation.setFieldValue('acceptedTerms', e.target.checked)
    }
    onBlur={validation.handleBlur}
  />
    I accept the{' '}
    <span
      className="text-secondary"
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => handleShowPopup('terms')}
    >
      Terms & Conditions
    </span>{' '}
    and{' '}
    <span
      className="text-secondary"
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => handleShowPopup('privacy')}
    >
      Privacy Policy
    </span>

  {validation.errors.acceptedTerms && validation.touched.acceptedTerms && (
    <div className="invalid-feedback d-block">
      {validation.errors.acceptedTerms}
    </div>
  )}
</div> */}



                                                        {/* <div className="mt-4">
                                                            <Button color="secondary" className="w-100" type="submit" data-testing-Id="submitButoon_otpVerification" >Submit</Button>
                                                            <Button color="dark" outline className='shadow-none w-100 mt-4' onClick={handleBack} data-testing-Id="backButoon_otpVerification"> Back </Button>
                                                        </div>
                                                    </Form> */}



                                                        <div id="password-contain" className="p-3 bg-light mb-2 rounded">
                                                            <h5 className="fs-13">Password must contain:</h5>
                                                            <p id="pass-length" className="invalid fs-12 mb-2">Minimum <b>8 characters</b></p>
                                                            <p id="pass-lower" className="invalid fs-12 mb-2">At <b>lowercase</b> letter (a-z)</p>
                                                            <p id="pass-upper" className="invalid fs-12 mb-2">At least <b>uppercase</b> letter (A-Z)</p>
                                                            <p id="pass-number" className="invalid fs-12 mb-0">A least <b>number</b> (0-9)</p>
                                                        </div>




       {/* <TermsPrivacyPopup
        show={termAndConditonModal}
        onCloseClick={() => setTermAndConditonModal(false)}
         type={type}
      /> */}

                                                        <div className="mt-4">
                                                            <Button color="secondary" className="w-100" type="submit" data-testing-Id="submitButoon_otpVerification"
                                                                disabled={loader}>
                                                                {loader && <Spinner size="sm" className="me-2"> Loading... </Spinner>}
                                                                Submit</Button>
                                                            <Button color="dark" outline className='shadow-none w-100 mt-2' onClick={handleBack} data-testing-Id="backButoon_otpVerification"> Back </Button>
                                                        </div>
                                                    </Form>

                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

            </div>
        </React.Fragment >
    );
};

export default withRouter(CoverTwosVerify);